/**
 * @file   path-map.js
 * @author rongtan<rongtan@baidu.com>
 * @date   2020-12-20
 */

// 配置模板路径和线上路径的对应关系，方便自测，非必填
const PATH_MAP = {
    '/page/home/index.tpl': '/web/home/index',
    '/page/gem-appraisal/index.tpl': '/web/promotion/dl',
    '/page/appraisal-detail/index.tpl': '/aappraisal/:id',
    '/page/long-img-text/index.tpl': '/article/:id',
    '/page/short-img-text/index.tpl': '/sarticle/:id'
};

export function getPagePath() {
    let pagePath = '';
    const env = process.env.NODE_ENV;
    const pathname = window.location.pathname;
    if (env === 'production') {
        pagePath = getResolvedProdPath(pathname);
    }
    else {
        pagePath = getProdPathByDev(pathname);
    }

    return pagePath;
}

function getProdPathByDev(pathname) {
    return PATH_MAP[pathname];
}

function getResolvedProdPath(pathname) {
    return pathname.replace(/\/[0-9a-z]{40}$/, '/:id');
}
